import { HttpMethod } from '@/constants/utils'
import { PRODUCT } from '@/utils'
import { createBillingApiRequest } from '@/utils/api'
import { IDirectChargeRequest } from './interfaces'

const read = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.GET,
    path: `/direct_charge/${productType}/${id}`,
  })

const readAll = (order_client_id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.GET,
    path: `/direct_charge/${productType}?order_client_id=${order_client_id}`,
  })

const create = ({
  name,
  price,
  quantity,
  return_url,
  per_account,
  clientId,
  test = false,
  product = PRODUCT.LiveChat,
}: IDirectChargeRequest) => {
  return createBillingApiRequest({
    method: HttpMethod.POST,
    path: `/direct_charge/${product}`,
    body: {
      name,
      price,
      quantity,
      return_url,
      order_client_id: clientId,
      per_account,
      test,
    },
  })
}

const activate = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/direct_charge/${productType}/${id}/activate`,
  })

const accept = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/direct_charge/${productType}/${id}/accept`,
  })

const decline = (id: string, productType = PRODUCT.LiveChat) =>
  createBillingApiRequest({
    method: HttpMethod.PUT,
    path: `/direct_charge/${productType}/${id}/decline`,
  })

export default {
  read,
  readAll,
  activate,
  create,
  accept,
  decline,
}
